import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { Commands } from "../core/util/commandManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { HTTPService } from "../core/util/httpManager";
import React from "react";

export class ResourcePlanningPMApp extends React.Component<ResourcePlanningPMAppProps, any> {
    private _defined = Helper.hasValue;
    private _saveUrl = "ResourcePlanningPM/Create";
    private _saveWithAufvorgUrl = "ResourcePlanningPM/CreateWithAufvorgInd";
    private _saveWithAufposUrl = "ResourcePlanningPM/CreateWithAufposInd";
    // 1=Basisauswahl (Projekt, Zeitraum, Produkt, Vorgang)
    // 2=Zusätzliche Vorgangsauswahl (aufvorg)
    // 3=Zusätzliche Positionsauswahl (aufpos)
    private _state = 1;
    common = new AppHelper();
    produktnummerDS = [];
    vorgangsnummerDS = [];
    aufposIndDS = [];


    constructor(props: ResourcePlanningPMAppProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }


    private _reloadProjectData = (projNr) => {
        HTTPService.get("ResourcePlanningPM/IsPMProjekt?projNr=" + encodeURIComponent(projNr))
            .then(result => {
                let valid = true;
                if (result.ErrorCode === 1) {
                    NotificationHelper.showErrorMessage(result.Message);
                    valid = false;
                }

                HTTPService.chainBatch
                    .add("ResourcePlanningPM/GetVorgangsvorlagen?projNr=" + encodeURIComponent(projNr))
                    .add(valid ? "ResourcePlanningPM/GetProdukte?projNr=" + encodeURIComponent(projNr) : null)
                    .promise()
                    .then(result => {
                        Helper.setArrayValues(this.vorgangsnummerDS, result[0]);
                        if (this.vorgangsnummerDS.length > 0) {
                            const vorgangField = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.Vorgangsnummer");
                            this.props.entity.Vorgangsnummer = this.vorgangsnummerDS[0][vorgangField.dataValueField];
                        }
                        this.common.commandManager.runCommand("entity.Vorgangsnummer", Commands.RELOADDATASOURCE);
                        if (result[1] !== null) {
                            Helper.setArrayValues(this.produktnummerDS, result[1]);
                            if (this.produktnummerDS.length > 0) {
                                const produktField = MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.Produktnummer");
                                this.props.entity.Produktnummer = this.produktnummerDS[0][produktField.dataValueField];
                            }
                            this.common.commandManager.runCommand("entity.Produktnummer", Commands.RELOADDATASOURCE);
                        }
                        this.setState({});
                    });
            });
    }

    private _updateTimes = (startDate, months) => {
        if (this._defined(startDate) && this._defined(months)) {
            var startIst = kendo.parseDate(startDate);
            var endeIst = kendo.parseDate(this.props.entity.EndeIst);
            var endDate = new Date(startIst.getTime());
            endDate.setMonth(endDate.getMonth() + months);
            if (months > 0) {
                endDate.setDate(endDate.getDate() - 1);
            }

            // Uhrzeit von EndeIst stehenlassen 
            if (this.props.entity.EndeIst !== null) {
                endDate.setHours(endeIst.getHours());
                endDate.setMinutes(endeIst.getMinutes());
                endDate.setSeconds(endeIst.getSeconds());
            }

            this.props.entity.EndeIst = Helper.dates.getISODateString(endDate);
        }
    }

    private _prepareDataForSend = (date: string | Date): string => {
        let tmp = date;
        if (typeof date === "string") {
            tmp = kendo.parseDate(date as string);
        }
        return kendo.toString(tmp as Date, "dd.MM.yyyy HH:mm");
    }


    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.StartIst":
                if (this._defined(value)) {
                    this._updateTimes(value, this.props.entity.DauerInMonaten);
                }
                break;
            case "entity.DauerInMonaten":
                if (typeof value === 'number' && value !== this.props.entity.DauerInMonaten) {
                    this._updateTimes(this.props.entity.StartIst, value);
                }
                break;
            case "entity.EndeIst":
                if (this._defined(value)) {
                    this.props.entity.DauerInMonaten = 0;
                }
                break;
            case "entity.ProjNr":
                this._reloadProjectData(value);
                break;
            default:
                break;
        }

        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    save = () => {
        if (this.common.validate()) {
            HTTPService.post(
                this._state === 1 ? this._saveUrl : (this._state === 2 ? this._saveWithAufvorgUrl : this._saveWithAufposUrl),
                {
                    projNr: this.props.entity.ProjNr,
                    start: this._prepareDataForSend(this.props.entity.StartIst),
                    end: this._prepareDataForSend(this.props.entity.EndeIst),
                    aufprodInd: this.props.entity.Produktnummer,
                    vorgangsnummer: this.props.entity.Vorgangsnummer,
                    resourceId: this.props.resourceId,
                    aufposInd: this._state === 3 ? this.props.entity.AufposInd : null
                })
                .then(result => {
                    switch (result.Code) {
                        case 0:
                            NotificationHelper.showSuccessMessage(Config.translations.savingSuccessfulMessage);
                            window["refreshScheduler"]();
                            this.common.handlePostSave(result.Code === 0, true);
                            const kWindow = $("#einsatzEdit_window").data("kendoWindow");
                            kWindow.center().open();
                            kWindow.refresh({
                                url: window["urlEdit"](),
                                data: { projNr: this.props.entity.ProjNr, pIndex: result.Message }
                            });
                            this.common.handlePostSave(true, true);
                            break;
                        case 1:
                            NotificationHelper.showErrorMessage(result.Message);
                            break;
                        case 3:
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.ProjNr", true);
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.StartIst", true);
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.DauerInMonaten", true);
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.EndeIst", true);
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.Produktnummer", true);
                            MetaDataHelper.setReadOnly(this.props.metadata, "entity.Vorgangsnummer", true);
                            MetaDataHelper.setVisibility(this.props.metadata, "entity.AufposInd", true);
                            MetaDataHelper.setRequired(this.props.metadata, "entity.AufposInd", true);
                            Helper.setArrayValues(this.aufposIndDS, result.ListSelectableAufpos);
                            this.common.commandManager.runCommand("entity.AufposInd", Commands.RELOADDATASOURCE);
                            NotificationHelper.showWarningMessage(result.Message);
                            this._state = 3;
                            this.setState({});
                            break;
                        case 2:
                        default:
                            NotificationHelper.showErrorMessage(`Unknonw result code: ${result.Code}.`);
                            break;
                    }
                });
        }
    }

    render() {
        this.props.dataSources.produktnummerDS = this.produktnummerDS;
        this.props.dataSources.vorgangsnummerDS = this.vorgangsnummerDS;
        this.props.dataSources.aufposIndDS = this.aufposIndDS;
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });

        return <CommonApp {...props} />;
    }
};

interface ResourcePlanningPMContext extends Context {
}

export interface ResourcePlanningPMAppProps extends AppBaseProps {
    context: ResourcePlanningPMContext;
    entity: ResourcePlanningPMEntity;
    resourceId: string;
}

export interface ResourcePlanningPMEntity extends Entity {
    ProjNr: string;
    StartIst: string;
    DauerInMonaten?: number;
    EndeIst: string;
    Produktnummer?: number;
    Vorgangsnummer?: number;
    AufvorgInd?: number;
    AufposInd?: number;
}